import { crudReducer } from "./dataHelper";

const initialState = () => ({
  projects: []
});

export default crudReducer("project", initialState);
